export default __webpack_public_path__ + "static/media/feedback-24-px.db82f5d7.svg";